const languages = {
  arabic: 'العربية',
  chinese: '中文',
  english: 'English',
  french: 'Français',
  russian: 'Русский',
  spanish: 'Español',
  portuguese: 'Português'
};

export default languages;



// WEBPACK FOOTER //
// ./src/resources/languages.js